import { collection, doc, getDocs, setDoc, query, where } from "firebase/firestore";
import { db } from "../config/firebase";

// ===== ĐÁNH GIÁ CUỐI KỲ =====
export const getDanhGiaByLop = async (lopId, hocKy) => {
  const q = query(
    collection(db, "danhGiaCuoiKy"),
    where("lopId", "==", lopId),
    where("hocKy", "==", hocKy)
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const saveDanhGia = async (data) => {
  const docId = `${data.lopId}_${data.hocSinhId}_${data.hocKy}_${data.namHoc}`;
  await setDoc(doc(db, "danhGiaCuoiKy", docId), {
    ...data,
    ngayCapNhat: new Date().toISOString(),
  }, { merge: true });
};

// ===== KỲ ĐÁNH GIÁ =====
export const getKyDanhGia = async (hocKy, namHoc) => {
  const docId = `${hocKy}_${namHoc}`;
  const q = query(
    collection(db, "kyDanhGia"),
    where("hocKy", "==", hocKy),
    where("namHoc", "==", namHoc)
  );
  const snapshot = await getDocs(q);
  if (snapshot.empty) return null;
  return { id: snapshot.docs[0].id, ...snapshot.docs[0].data() };
};

export const saveKyDanhGia = async (data) => {
  const docId = `${data.hocKy}_${data.namHoc}`;
  await setDoc(doc(db, "kyDanhGia", docId), data, { merge: true });
};

// ===== TÍNH ĐIỂM TB =====
export const getDiemTBHocKy = async (hsId, hocKy) => {
  const diemSnapshot = await getDocs(collection(db, "hocSinh", hsId, "diemSo"));
  const diemList = diemSnapshot.docs.map(d => d.data()).filter(d => d.hocKy === hocKy);
  
  const m = diemList.filter(d => d.loaiDiem === 'mieng').map(d => d.diem);
  const m15 = diemList.filter(d => d.loaiDiem === '15phut').map(d => d.diem);
  const m1 = diemList.filter(d => d.loaiDiem === '1tiet').map(d => d.diem);
  const hk = diemList.filter(d => d.loaiDiem === 'hocKy').map(d => d.diem);
  
  if (!m.length || !m15.length || !m1.length || !hk.length) return null;
  
  const tbMieng = m.reduce((a, b) => a + b, 0) / m.length;
  const tb15Phut = m15[0];
  const tb1Tiet = m1[0];
  const tbHocKy = hk[0];
  
  return parseFloat(((tbMieng + tb15Phut + tb1Tiet * 2 + tbHocKy * 3) / 7).toFixed(1));
};

// ===== TÍNH CHUYÊN CẦN =====
export const getChuyenCanHocKy = async (hsId, lopId, hocKy) => {
  const ddSnapshot = await getDocs(
    query(collection(db, "diemDanh"),
      where("hocSinhId", "==", hsId),
      where("lopId", "==", lopId))
  );
  const ddList = ddSnapshot.docs.map(d => d.data());
  
  // Lọc theo học kỳ
  const filtered = ddList.filter(d => {
    const month = parseInt(d.ngayHoc?.split('-')[1] || '0');
    if (hocKy === 'HK1') return month >= 8 && month <= 12;
    return month >= 1 && month <= 5;
  });
  
  if (!filtered.length) return { tong: 0, coMat: 0, vangKP: 0, chuyenCan: 0 };
  
  const tong = filtered.length;
  const coMat = filtered.filter(d => d.trangThai === 'coMat' || d.trangThai === 'diTre').length;
  const vangKP = filtered.filter(d => d.trangThai === 'vangKhongPhep').length;
  const chuyenCan = Math.round((coMat / tong) * 100);
  
  return { tong, coMat, vangKP, chuyenCan };
};

// ===== GỢI Ý XẾP LOẠI =====
export const getGoiYXepLoai = (diemTB, chuyenCan, vangKP) => {
  if (vangKP > 3) return { loai: 'trungBinh', lyDo: 'Vắng không phép quá 3 buổi' };
  if (chuyenCan < 70) return { loai: 'yeu', lyDo: `Chuyên cần chỉ ${chuyenCan}%` };
  if (diemTB === null) return { loai: null, lyDo: 'Chưa đủ điểm để tính TB' };
  
  if (diemTB >= 9.0 && chuyenCan >= 95) return { loai: 'xuatSac', lyDo: `ĐTB ${diemTB}, CC ${chuyenCan}%` };
  if (diemTB >= 8.0 && chuyenCan >= 85) return { loai: 'gioi', lyDo: `ĐTB ${diemTB}, CC ${chuyenCan}%` };
  if (diemTB >= 6.5 && chuyenCan >= 75) return { loai: 'kha', lyDo: `ĐTB ${diemTB}, CC ${chuyenCan}%` };
  if (diemTB >= 5.0 && chuyenCan >= 70) return { loai: 'trungBinh', lyDo: `ĐTB ${diemTB}, CC ${chuyenCan}%` };
  
  return { loai: 'yeu', lyDo: `ĐTB ${diemTB}, CC ${chuyenCan}%` };
};
// Đếm số HS CHƯA hoàn thành đánh giá trong 1 lớp
export const countChuaDanhGia = async (lopId, hocKy, namHoc) => {
  const q = query(
    collection(db, "danhGiaCuoiKy"),
    where("lopId", "==", lopId),
    where("hocKy", "==", hocKy),
    where("namHoc", "==", namHoc),
    where("trangThai", "==", "daHoanThanh")
  );
  const snapshot = await getDocs(q);
  return snapshot.size; // Số đã hoàn thành → cần tổng HS - số này
};